// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__33_8B","title":"AfterFrontImage_title__2lVCr"};